import logo from '../images/logo.png'
export default function NavBar({ user, setUser }) {
	return (
		<div className={`nav nav__website`}>
			<div className="flex flex__row justify__cennter">
				<a className="nav__logo btn btn__transparent" href="/">
					<img src={logo} width={250} />
				</a>
			</div>
			<div className="nav__items">
				{/* <a className="btn btn__transparent">
					Features
				</a>
				<a className="btn btn__transparent">
					Contact
				</a> */}
				<a className="btn btn__secondary btn__rounded" href="/login">
					<span className="material-icons">
						login
					</span>
					Login / Register
				</a>
			</div>
		</div>
	)
}